import classNames from 'classnames';

type IconProps = {
  className?: string;
} & any;

export default function PhoneIcon({ className, ...props }: IconProps) {
  return (
    <svg
      width="12"
      height="19"
      viewBox="0 0 12 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      className={classNames('stroke-current fill-current stroke-0', className)}
      {...props}
    >
      <rect
        x="1"
        y="1"
        width="10"
        height="17"
        rx="2"
        stroke="currentColor"
        stroke-width="2"
      />
      <path d="M0 13.1916H6H12" stroke="currentColor" stroke-width="2" />
      <line
        y1="5.16304"
        x2="12"
        y2="5.16304"
        stroke="currentColor"
        stroke-width="2"
      />
      <ellipse cx="6" cy="15.7731" rx="0.6" ry="0.64538" fill="currentColor" />
    </svg>
  );
}
